import React from 'react'
import { Box } from 'pcln-design-system'
import { FilterSkeleton } from '@pcln/fly-ui-components'
import styled from 'styled-components'
import qs from 'query-string'

const StyledFilterSkeleton = styled(FilterSkeleton)`
  line-height: 20px;
  ${typeof window === 'undefined' && 'margin-top: 24px;'}
`

const LeftFilterSkeleton = () => {
  const queryParams = qs.parse(window.location.search)
  const isAltDatesSearch = queryParams['alt-dates'] === 'true'

  return (
    <Box pl={1} pt={'9px'}>
      <StyledFilterSkeleton
        showTitles
        repeat={isAltDatesSearch ? 4 : 5}
        sectionTitles={
          isAltDatesSearch
            ? ['Stops', 'Airlines', 'Time', 'Airports']
            : ['Stops', 'Airlines', 'Time', 'Duration', 'Airports']
        }
      />
    </Box>
  )
}

LeftFilterSkeleton.displayName = 'FilterSkeleton'

export { LeftFilterSkeleton }
